import * as React from 'react';
import {Dialog} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { traducirButton } from '../../blocks/traductor';

interface Props {
    titulo: string
    contenido: string
    abierto: boolean
    confirmar: () => void
    cerrar: () => void
    maxWidth?: 'lg'| 'md'| 'sm'| 'xl' 
}

const ConfirmDialog = ({titulo, contenido, abierto, confirmar,cerrar, maxWidth}: Props) => {
    return (<>
        <Dialog open={abierto} maxWidth={maxWidth? maxWidth: "sm"} fullWidth={true} onClose={cerrar}>
            <DialogTitle id="simple-dialog-title">{titulo}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    {contenido}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button autoFocus onClick={confirmar} color="primary">
                {traducirButton(7)}
                </Button>

                <Button autoFocus onClick={cerrar} color="secondary">
                    {traducirButton(6)}
                </Button>
            </DialogActions>
        </Dialog>
    </>)
};

export default ConfirmDialog;
